import { encrypt } from "@umami/crypto";
import { type AccountsState, type Backup } from "@umami/state";

import { type RegisterFn } from "../../hooks/usePasskey";

export const getEncryptedBackupForPasskey = async (backup: Backup, register: RegisterFn) => {
  const { dek: password, passkey_kek, userId, verified } = await register();

  if (verified) {
    const encrypted_dek = await encrypt(password, passkey_kek);
    const accountState = {
      defaultAccount: {
        ...backup.accounts.defaultAccount,
        encrypted_dek,
        userId,
      },
      items: backup.accounts.items.map(item =>
        item.type === "mnemonic" || item.type === "secret_key"
          ? {
              ...item,
              encrypted_dek,
              userId,
            }
          : item
      ),
    } as AccountsState;

    return {
      accountState,
      password,
    };
  }

  return {};
};
